import * as C from '../constants';

export default {
  [C.GIFT_VOUCHER_DOMAINS_PENDING](state) {
    state.domains = {
      ...state.domains,
      loading: true,
      error: false,
      items: [],
    };
  },
  [C.GIFT_VOUCHER_DOMAINS_FAILURE](state) {
    state.domains = {
      ...state.domains,
      loading: false,
      error: true,
    };
  },
  [C.GIFT_VOUCHER_DOMAINS_SUCCESS](state, payload) {
    state.domains = {
      ...state.domains,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.GIFT_VOUCHER_BOOKING_LIST_SEARCH_PENDING](state) {
    state.bookingList.bookings = {
      ...state.bookingList.bookings,
      loading: true,
      error: false,
      items: [],
    };
  },
  [C.GIFT_VOUCHER_BOOKING_LIST_SEARCH_FAILURE](state) {
    state.bookingList.bookings = {
      ...state.bookingList.bookings,
      loading: false,
      error: true,
    };
  },
  [C.GIFT_VOUCHER_BOOKING_LIST_SEARCH_SUCCESS](state, payload) {
    state.bookingList.bookings = {
      ...state.bookingList.bookings,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.GIFT_VOUCHER_BOOKING_LIST_SEARCH_NO_CONTENT](state) {
    state.bookingList.bookings = {
      ...state.bookingList.bookings,
      loading: false,
      error: false,
      items: [],
    };
  },
  [C.GIFT_VOUCHER_BOOKING_LIST_SEND_PENDING](state) {
    state.bookingList.sendingMails = {
      loading: true,
      error: false,
    };
  },
  [C.GIFT_VOUCHER_BOOKING_LIST_SEND_FAILURE](state) {
    state.bookingList.sendingMails = {
      loading: false,
      error: true,
    };
  },
  [C.GIFT_VOUCHER_BOOKING_LIST_SEND_SUCCESS](state) {
    state.bookingList.sendingMails = {
      loading: false,
    };
  },
  [C.GIFT_VOUCHER_EMAIL_LIST_SEARCH_PENDING](state) {
    state.emailList.bookings = {
      ...state.emailList.bookings,
      loading: true,
      error: false,
      items: [],
    };
  },
  [C.GIFT_VOUCHER_EMAIL_LIST_SEARCH_FAILURE](state) {
    state.emailList.bookings = {
      ...state.emailList.bookings,
      loading: false,
      error: true,
    };
  },
  [C.GIFT_VOUCHER_EMAIL_LIST_SEARCH_SUCCESS](state, payload) {
    state.emailList.bookings = {
      ...state.emailList.bookings,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.GIFT_VOUCHER_EMAIL_LIST_SEARCH_NO_CONTENT](state) {
    state.emailList.bookings = {
      ...state.emailList.bookings,
      loading: false,
      error: false,
      items: [],
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucher/mutations.js